/**
 * Renderer for the tag key label in the group row header.
 * Administrators will get a link to the edit view for the given key.
 */
import React from 'react';
import { inject, observer } from 'mobx-react';
import { IReactComponent } from 'mobx-react/dist/types/IReactComponent';
import { Link } from 'core/components';
import { AuthStore } from 'app/$store.types';
import AssetTagInventoryModel from 'app/stores/assetTags/AssetTagInventoryModel';

interface Props {
  $auth: AuthStore;
  group: AssetTagInventoryModel[];
}

function LabelRenderer({ $auth, group }: Props) {
  const [model] = group;

  if (model) {
    const tagName = model.get('tag_name');

    if ($auth.isAdministrator) {
      return <Link to={`/v4/settings/tags/edit/${model.get('tag_id')}`}>{tagName}</Link>;
    }

    return tagName;
  }

  return 'Unassigned';
}

export default inject('$auth')(observer(LabelRenderer as IReactComponent));
